module.exports = {
      id: "ic-metal-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dbc6d5.smartcharts.svg#ic-metal-usage",
      toString: function () {
        return this.url;
      }
    }